"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MockAnalyticsStore = exports.load = exports.getBaseProperty = exports.waitForBaseProperties = exports.track = exports.setBaseProperties = exports.identify = void 0;
var segment_1 = __importDefault(require("./segment"));
/**
 * Identify the user to Segment
 *
 * @param userUid The user's Analytics UID
 * @param traits The entitlements User object
 */
var identify = function (userAnalyticsId, traits) {
    segment_1.default.identify(userAnalyticsId, traits);
};
exports.identify = identify;
exports.setBaseProperties = segment_1.default.setBaseProperties;
exports.track = segment_1.default.track;
exports.waitForBaseProperties = segment_1.default.waitForBaseProperties;
exports.getBaseProperty = segment_1.default.getBaseProperty;
exports.load = segment_1.default.load;
var MockAnalyticsStore_1 = require("./MockAnalyticsStore");
Object.defineProperty(exports, "MockAnalyticsStore", { enumerable: true, get: function () { return __importDefault(MockAnalyticsStore_1).default; } });
